import type { MapCapabilities } from './types';

/**
 * Detects device capabilities that influence future map interactions.
 *
 * @returns Resolved capability flags for hover and pointer precision.
 */
export function detectMapCapabilities(): MapCapabilities {
  const hasHoverCapability = window.matchMedia('(hover: hover)').matches;
  const hasFinePointer = window.matchMedia('(pointer: fine)').matches;

  return {
    hasHoverCapability,
    hasFinePointer,
  };
}
